import React from 'react';
import { BannerTypes } from '@gin-betting/banners';
import { GQL } from '@gin-betting/core';
import {
    BannerZoneLocation,
    SportEventBannerTheme,
} from '@gin-betting/constants';
import cn from 'classnames';

import { AsyncOddButton } from 'modules/betslip/async';
import favorite from 'modules/favorite';
import { PromoItem } from 'components';
import CMSBanner from '../CMSBanner';
import './banners.scss';

const { ToggleFavoriteButton } = favorite.components;

interface Props {
    banner: BannerTypes.BannerItem;
    zoneLocation: BannerZoneLocation;
}

const Banner: React.FC<Props> = ({ banner, zoneLocation }) => {
    switch (banner.type) {
        case GQL.BannerType.betting_live_of_the_day:
        case GQL.BannerType.betting_match_of_the_day:
        case GQL.BannerType.betting_sport_event: {
            const { id: matchId, type } = banner;

            if (!matchId) return null;

            const sharedProps: React.ComponentProps<typeof PromoItem> = {
                matchId,
                AsyncOddButton,
                type,
                favoriteButton: <ToggleFavoriteButton matchId={matchId} />,
            };

            if (zoneLocation === BannerZoneLocation.TOP_SLIDER) {
                if (
                    banner.type === GQL.BannerType.betting_sport_event &&
                    banner.theme === SportEventBannerTheme.Colorful
                ) {
                    return (
                        <div styleName={cn('top-zone-banners', 'is-colorful')}>
                            <PromoItem
                                footer={null}
                                {...sharedProps}
                                isColorful={true}
                            />
                        </div>
                    );
                }

                return (
                    <div styleName="top-zone-banners">
                        <PromoItem footer={null} {...sharedProps} />
                    </div>
                );
            }

            return <PromoItem {...sharedProps} />;
        }

        // TODO Ask for design
        // case GQL.BannerType.betting_tournament: {
        //     const { id: tournamentId } = banner;
        //
        //     return (
        //         null
        //     );
        // }

        case GQL.BannerType.cms_banner: {
            return <CMSBanner bannerId={banner.id} />;
        }

        default: {
            return null;
        }
    }
};

export default Banner;
